export const CELEBRUS_LOGIN_STATE_KEY = 'celebrusLoginState';
export const PORTAL_LOGIN_STATE_KEY = 'portalLoginState';
export const NAVBAR_HEADER_HEIGHT = 80;
export const DNB_TENANT_ID = '4cbfea0a-b872-47f0-b51c-1c64953c3f0b';
